<template>
    <section>
        <div class="row">
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                <div class="field">
                    <label>สถานะ</label>
                    <dropdown
                        v-model="formFilter.status"
                        placeholder="-- สถานะของใบงาน --"
                        :options="option.jobStatus"
                        :classes="{ input: 'input-field' }"
                    ></dropdown>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                <div class="field">
                    <label>คีย์เวิด</label>
                    <input type="text" 
                        v-model="formFilter.keyword"
                        class="input-field"
                        maxlength="50"
                        placeholder="เลขที่/ชื่อลูกค้า/ทะเบียนรถ" />
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                <div class="field">
                    <label>วันที่เปิดงาน</label>
                    <div class="input-component-range">
                        <div class="input-component input-datepicker">
                            <datepicker input-class="input-field"
                                calendar-class="gadget-datepicker-box"
                                placeholder="จาก"
                                format="d/M/yyyy"
                                v-model="formFilter.openDateFrom">
                            </datepicker>
                            <b-icon icon="calendar2-minus"></b-icon>
                        </div>
                        <div class="input-component input-datepicker">
                            <datepicker input-class="input-field"
                                calendar-class="gadget-datepicker-box"
                                placeholder="ถึง"
                                format="d/M/yyyy"
                                v-model="formFilter.openDateTo">
                            </datepicker>
                            <b-icon icon="calendar2-minus"></b-icon>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                <div class="field">
                    <label class="no-label">-</label>
                    <button class="btn btn-main" @click="searchJob()"><b-icon icon="search"></b-icon> ค้นหาใบงาน</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import OptionJobStatus from '@/database/staticOption/JobStatus';
import OptionClaimStatus from '@/database/staticOption/ClaimStatus';
import ModelJobFilter from '@/resources/models/JobFilter';

export default {
    data() {
        return {
            formFilter: this.initFormFilter(),
            option: { jobStatus: this.isClaim ? OptionClaimStatus.option : OptionJobStatus.option }
        }
    },
    props: {
        isClaim: Boolean
    },
    methods: {
        initFormFilter() {
            return ModelJobFilter.data();
        },
        searchJob() {
            this.$emit('lookup', this.formFilter);
        }
    }
}
</script>